import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Header, Segment, Form, Button, Grid, Icon, Divider, List } from 'semantic-ui-react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import classes from "./FootersPages.module.css";

const ContactUs = () => {
    const { t } = useTranslation();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      
      try {
        await addDoc(collection(db, 'contacts'), {
          name,
          email,
          message,
          timestamp: new Date(),
        });
        setSuccessMessage(t('contact_us.success_message'));
        setName('');
        setEmail('');
        setMessage('');
      } catch (error) {
        console.error("Error adding document: ", error);
      }
    };
  
    return (
      <Container style={{ padding: '3em 0em' }}>
        <Segment basic textAlign="center">
          <Header as="h1" style={{ fontSize: '2.5em', color: '#fff' }}>{t('contact_us.header')}</Header>
          <p style={{ fontSize: '1.33em', color: '#fff' }}>{t('contact_us.description')}</p>
        </Segment>
        
        <Divider section />
  
        <Segment>
          <Grid columns={2} textAlign="left">
            <Grid.Column width={8}>
              <Header as="h2" style={{ fontSize: '2em' }}>{t('contact_us.get_in_touch')}</Header>
              <p style={{ fontSize: '1.2em' }}>{t('contact_us.send_us_a_message')}</p>
              <Header as="h3">{t('contact_us.contact_information')}</Header>
              <p><Icon name="mail" /> contact@fablia.fr</p>
              <p><Icon name="phone" /> (+33) 07 69 22 32 74</p>
            </Grid.Column>
            <Grid.Column width={8}>
              <Header as="h2" style={{ fontSize: '2em' }}>{t('contact_us.send_us_a_message')}</Header>
              <Form onSubmit={handleSubmit}>
                <Form.Field>
                  <label>{t('contact_us.name')}</label>
                  <input 
                    placeholder={t('contact_us.name')} 
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required 
                  />
                </Form.Field>
                <Form.Field>
                  <label>{t('contact_us.email')}</label>
                  <input 
                    type="email" 
                    placeholder={t('contact_us.email')} 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required 
                  />
                </Form.Field>
                <Form.Field>
                  <label>{t('contact_us.message')}</label>
                  <textarea 
                    placeholder={t('contact_us.message')} 
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required 
                  />
                </Form.Field>
                <Button primary type='submit'>{t('contact_us.submit')}</Button>
              </Form>
              {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
            </Grid.Column>
          </Grid>
        </Segment>
        
        <Divider section />
        
        <Segment className={`${classes.aboutus}`} textAlign="center" basic>
          <Header as="h3">{t('contact_us.header')}</Header>
          <List horizontal divided link size="large">
            <List.Item as="a" href="mailto:contact@fablia.fr">{t('contact_us.email_us')}</List.Item>
            <List.Item as="a" href="https://www.facebook.com/people/Fablia/61574400869813/">Facebook</List.Item>
            <List.Item as="a" href="https://www.instagram.com/fablia_fr">Instagram</List.Item>
          </List>
        </Segment>
      </Container>
    );
  };

export default ContactUs;